import Axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import config from '../../Config/key';
import { DEFAULT_BCC_EMAIL } from '../../Config/mailConfig';
import {
  Table,
  Button,
  message,
  Typography,
  Select,
  Modal,
  Input,
  DatePicker,
} from 'antd';
import { userRole } from '../../Config/userRole';
import { useSelector } from 'react-redux';
import moment from 'moment';
// テーブル強化 PJ Ph.3 拡大: 列リサイズ + ソート + 省略
import {
  PageContainer,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
} from '../../common';
const ExcelJS = require('exceljs');
const { Text } = Typography;
const { confirm } = Modal;
const { Option } = Select;

const MailSendReservatePage = (props) => {
  const [isAnswerd, setIsAnswerd] = useState(9); // 実施選択（9:全体 / 0:未回答 / 5:回答済み / 99:ユーザー選択）
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // ユーザー選択（isAnswerd===99）時のチェック対象
  const [tUsers, setTUsers] = useState([]); //グループフィルタリングされたユーザ一覧（全体）
  const [gUsers, setGUsers] = useState([]); //グループ・サーベイシーズンでフィルタリングされたユーザ一覧
  const [searchName, setSearchName] = useState(''); // 対象者リスト内の名前検索（表示絞り込みのみ）
  const [searchEmail, setSearchEmail] = useState(''); // 対象者リスト内のメール検索（表示絞り込みのみ）
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selGroupInfo, setSelGroupInfo] = useState([]); //グループ名とグループコード
  const [surveySeason, setSurveySeason] = useState([]);
  const [selGroupCode, setSelGroupCode] = useState(''); //選択されたグルプコード
  const [survey, setSurvey] = useState([]); //サーベイ名とサーベイコード
  const [selSurvey, setSelSurvey] = useState([]); //サーベイ名とサーベイコード
  const [questionSet, setQuestionSet] = useState([]); //全ての設問セット
  const [selSurveyId, setSelSurveyId] = useState(''); //選択したサーベイID
  const [selSurveySeasonId, setSelSurveySeasonId] = useState(''); //選択したサーベイID
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState({}); //選択したサーベイID
  const [selSurveySeasonIdFilter, setSelSurveySeasonIdFilter] = useState(''); //選択したサーベイID
  const [selQuestionSetId, setSelQuestionSetId] = useState(''); //選択した設問セットID
  const [selQuestionSetInfo, setSelQuestionSetInfo] = useState({}); //選択した設問セットID
  const [mtInfo, setMtInfo] = useState([]);
  const [selMtId, setSelMtId] = useState('');
  const [ccMailValue, setCCMailValue] = useState('');
  const [bccMailValue, setBCCMailValue] = useState(DEFAULT_BCC_EMAIL);
  const [testMailValue, setTestMailValue] = useState('');
  const [sendDateTime, setSendDateTime] = useState(null); // 送信予定日時
  const usr = useSelector((state) => state.user);

  const readDB = async () => {
    try {
      if (!usr.userData) return null;

      const [surveyInfo, groupInfo, seasonInfo, mtInfo] = await Promise.all([
        Axios.get('/api/survey/'), //DBからサーベイ情報取得
        Axios.get('/api/group/'), //DBからグループ情報取得
        Axios.get('/api/surveySeason/'), //DBからシーズン情報取得
        Axios.get('/api/mailTemplate/'),
      ]);
      setGroups(groupInfo.data.groups);
      setSurvey(surveyInfo.data.survey);
      setSurveySeason(seasonInfo.data.surveySeason);
      setMtInfo(mtInfo.data.mailTemplate);
      setGUsers([]);
      setTUsers([]);
      if (!groups) throw 'グループ取得に失敗しました。';
      if (!survey) throw 'サーベイ取得に失敗しました。';
      if (!seasonInfo) throw 'サーベイシーズン取得に失敗しました。';
      if (!mtInfo) throw 'メールテンプレート取得に失敗しました。';
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
  }, [usr]);

  //リストフィルタリング
  const filterDatasource = async (groupCode) => {
    message.loading({ content: '読み込み中...', key: 'loading', duration: 20 });
    const res = await Axios.get(`${config.USER_SERVER}/group/${groupCode}`);
    let userData = res.data.users;
    await userData.map((user) => {
      user.fullName = user.lastname + ' ' + user.name;
      user.roleText = userRole[user.role];
      if (user.survey_token.length === 0) {
        user.takeTokenCnt = 0;
        user.usedTokenCnt = 0;
        user.surveyProgress = 0;
      } else {
        user.takeTokenCnt = user.survey_token.length;
        user.usedTokenCnt = user.survey_token.filter(function (tokenInfo) {
          return tokenInfo.survey_status === 5; //実施済み：5
        }).length;
        user.surveyProgress = (user.usedTokenCnt / user.takeTokenCnt) * 100;
      }
      return user;
    });
    setGUsers(userData);
    setTUsers(userData);
    message.success({
      content: '読み込み完了！',
      key: 'loading',
      duration: 2,
    });
  };

  //グループを変更した場合
  const onChangeGroup = async (value) => {
    setSelGroupCode(value);
    filterDatasource(value); //リストフィルタリング
    const selGroup = groups.find((item) => item.group_code === value);
    setSelGroupInfo(selGroup);
    setQuestionSet([]);
    setSelSurveyId('');
    setSelSurveySeasonId('');
    setSelSurveySeasonIdFilter('');
    setSelQuestionSetId('');
    // setIsAnswerd(9); // 全体に固定のため変更しない
  };

  //サーベイシーズンを変更した場合
  const onChangeSeason = async (value) => {
    setSelSurveySeasonId(value);
    const selSeasonInfo = selGroupInfo.survey_season.find(
      (item) => item._id === value
    );
    const arrQuestionSet = selSeasonInfo.question_set;
    setSelSurveySeasonInfo(selSeasonInfo);
    setSelSurveyId(selSeasonInfo.survey_id);
    setQuestionSet(arrQuestionSet);
    setSelQuestionSetId('');
    // setIsAnswerd(9); // 全体に固定のため変更しない
  };

  //サーベイシーズンを変更した場合
  const onChangeSeasonFilter = async (value) => {
    await onChangeSeason(value);
    setSelSurveySeasonIdFilter(value);
    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        token = element.survey_token.find(
          (item) => item.survey_season_id === value
        );
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    setIsAnswerd(9); // シーズン変更で実施選択を全体へリセット
    setSelectedRowKeys([]);
    setGUsers(gUserArr);
  };

  //設問セットを変更した場合
  const onChangeQuestionSet = (value) => {
    setIsAnswerd(9); // 設問セット変更で実施選択を全体へリセット
    setSelectedRowKeys([]);

    // 360度「全体」（sentinel '__ALL__'）= 本人/協力者を区別せず重複なしで1通配信。
    // question_set_id は空（発送時 getMailTargets がシーズン単位で User dedup）、
    // sub_type='ALL'（設問数は協力者基準、{$target$} は未使用）。
    // 表示名は選択肢と同じ '全回答者'（予約一覧の「設問セット名」もこの値を表示）。
    if (value === '__ALL__') {
      setSelQuestionSetId('__ALL__');
      setSelQuestionSetInfo({
        sub_type: 'ALL',
        set_name: '全回答者',
        survey_code: selSurveySeasonInfo.survey_code,
      });
      const gUserArr = [];
      for (let i = 0; i < tUsers.length; i++) {
        const element = tUsers[i];
        if (
          element.survey_token &&
          element.survey_token.find(
            (item) => item.survey_season_id === selSurveySeasonIdFilter
          )
        ) {
          gUserArr.push(element); // シーズン単位で重複なし（本人/協力者を合算して1名1行）
        }
      }
      setGUsers(gUserArr);
      return;
    }

    setSelQuestionSetId(value); //選択した設問セットIDを格納
    const selQuestionSet = questionSet.find((item) => item._id === value);
    setSelQuestionSetInfo(selQuestionSet); //現在選択したQuestionSet

    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        token = element.survey_token.find(
          (item) =>
            item.question_set_id === value &&
            item.survey_season_id === selSurveySeasonIdFilter
        );
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    setGUsers(gUserArr);
  };

  //実施有無（9:全体 / 0:未回答 / 5:回答済み / 99:ユーザー選択）
  const onChangeAnswer = (value) => {
    setIsAnswerd(value);
    setSelectedRowKeys([]); // 実施選択を変えたらユーザー選択はリセット

    // 表示用にトークン状態でテーブルを絞り込む（実発送時はサーバー側 getMailTargets が
    // 同条件で再判定する。未回答/回答済みは送信時点の状態が基準になるため表示は目安）。
    // 360度「全体」（'__ALL__'）はシーズン単位（本人/協力者を区別せず重複なし）。
    // selQuestionSetId が '__ALL__' のときは設問セットで絞り込まずシーズンのみで判定する。
    const isAll = selQuestionSetId === '__ALL__';
    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      if (!element.survey_token) continue;
      let token;
      if (selQuestionSetId && !isAll) {
        token = element.survey_token.find(
          (item) =>
            item.question_set_id === selQuestionSetId &&
            item.survey_season_id === selSurveySeasonIdFilter
        );
      } else {
        token = element.survey_token.find(
          (item) => item.survey_season_id === selSurveySeasonIdFilter
        );
      }
      if (!token) continue;
      // 0:未回答 / 5:回答済み のみ状態で絞り込む。9:全体・99:ユーザー選択は全件表示
      if (value === 0 && token.survey_status !== 0) continue;
      if (value === 5 && token.survey_status !== 5) continue;
      gUserArr.push(element);
    }
    setGUsers(gUserArr);
  };

  //yyyy/mm/dd hh:mm
  const ymdhms = (tdate) => {
    let date = new Date(tdate);
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2)
    );
  };

  //メール配信予約
  const sendMailReservateHandler = async () => {
    try {
      if (!sendDateTime) {
        message.error('送信予定日時を選択してください。');
        return;
      }

      message.loading({ content: 'メール配信予約中...', key: 'mail' });
      const selMtInfo = mtInfo.find((item) => item._id === selMtId);
      const ccString = ccMailValue
        .replace(/\s+/g, '') //文字列の中の空白を削除
        .replace(/(^[;]+)|([;]+$)/g, ''); //文字列前後の「;」を削除
      const bccString = bccMailValue
        .replace(/\s+/g, '') //文字列の中の空白を削除
        .replace(/(^[;]+)|([;]+$)/g, ''); //文字列前後の「;」を削除
      let cc = [];
      let bcc = [];
      let ccArr = [];
      let bccArr = [];
      if (ccString) {
        cc = ccString.split(';');
        cc.map((element) => {
          ccArr.push({ email: element });
        });
      }
      if (bccString) {
        bcc = bccString.split(';');
        bcc.map((element) => {
          bccArr.push({ email: element });
        });
      }

      // メール送信予約をDBに保存（フィルター条件を保存）
      const reservateResult = await Axios.post('/api/sendMail/reservate', {
        group_name: selGroupInfo.group_name,
        survey_name: selSurvey.survey_name,
        season_name: selSurveySeasonInfo.season_name,
        set_name: selQuestionSetInfo.set_name || '',
        mt_name: selMtInfo.mt_name,
        mt_id: selMtId, // テンプレートIDを保存（発送時点で参照）
        send_date_time: sendDateTime.toDate(),
        isAnswerd: isAnswerd.toString(),
        // フィルター条件を追加（発送時点で対象者を決定）
        group_code: selGroupCode,
        // 設問セット未選択（設問マッチングしないサーベイ等）でも
        // シーズン自体の survey_code でフォールバックして空文字保存を防止
        survey_code:
          selQuestionSetInfo.survey_code ||
          selSurveySeasonInfo.survey_code ||
          '',
        survey_id: selSurveyId,
        survey_season_id: selSurveySeasonIdFilter,
        // 360度「全体」（'__ALL__'）はシーズン単位配信のため question_set_id は空で保存
        question_set_id:
          selQuestionSetId === '__ALL__' ? '' : selQuestionSetId || '',
        question_set_sub_type: selQuestionSetInfo.sub_type || '',
        // ユーザー選択（99）時のみ、選択された対象者ID（参照IDのみ）を保存。
        // 発送時点に getMailTargets が当該IDの最新ユーザー情報を live 取得する。
        selected_user_ids: isAnswerd === 99 ? selectedRowKeys : [],
        cc: ccArr,
        bcc: bccArr,
      });

      if (reservateResult.data.success) {
        message.success({
          content: 'メール送信予約完了！',
          key: 'mail',
          duration: 2,
        });
        return reservateResult;
      } else {
        message.error({
          content: 'メール送信予約に失敗しました。',
          key: 'mail',
          duration: 2,
        });
        throw new Error('メール送信予約に失敗しました。');
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: 'メール配信予約で問題が発生しました。',
        key: 'mail',
        duration: 2,
      });
    }
  };

  const searchUser = (userId) => {
    let heroId = [];
    const { survey_token } = tUsers.find((item) => item._id === userId);

    // 配信対象(isAnswerd)に応じて {$target$} に列挙する hero を絞り込む
    //   0=未回答のみ / 5=回答済みのみ / 9・99・その他=全件（予約発送の searchUserFor360 と統一）
    const statusMatches = (status) => {
      if (isAnswerd === 0) return status === 0;
      if (isAnswerd === 5) return status === 5;
      return true;
    };

    selSurveySeasonInfo.relation_360.map((item) => {
      item.boss.map((item2) => {
        if (item2 === userId) {
          const t = survey_token.find(
            (item3) =>
              statusMatches(item3.survey_status) &&
              item3.hero_id === item.user_id &&
              item3.survey_season_id === item.survey_season_id
          );
          if (t) {
            heroId.push(item.user_id);
          }
        }
      });
      item.partner.map((item2) => {
        if (item2 === userId) {
          const t = survey_token.find(
            (item3) =>
              statusMatches(item3.survey_status) &&
              item3.hero_id === item.user_id &&
              item3.survey_season_id === item.survey_season_id
          );
          if (t) {
            heroId.push(item.user_id);
          }
        }
      });
      item.sub.map((item2) => {
        if (item2 === userId) {
          const t = survey_token.find(
            (item3) =>
              statusMatches(item3.survey_status) &&
              item3.hero_id === item.user_id &&
              item3.survey_season_id === item.survey_season_id
          );
          if (t) {
            heroId.push(item.user_id);
          }
        }
      });
    });
    let targetText = '';
    for (let i = 0; i < heroId.length; i++) {
      const heroInfo = tUsers.find((item) => item._id === heroId[i]);
      if (i === 0) {
        targetText += `${heroInfo.lastname} ${heroInfo.name}`;
      } else {
        targetText += `、${heroInfo.lastname} ${heroInfo.name}`;
      }
    }

    return targetText;
  };

  //テストメール配信
  const sendTestMailHandler = async () => {
    let mailList = {}; //最終分類用
    try {
      message.loading({ content: 'テストメール配信中...', key: 'mail' });
      const selMtInfo = mtInfo.find((item) => item._id === selMtId);
      const testMailString = testMailValue
        .replace(/\s+/g, '') //文字列の中の空白を削除
        .replace(/(^[;]+)|([;]+$)/g, ''); //文字列前後の「;」を削除
      let testMail = [];
      let testMailArr = [];
      if (testMailString) {
        testMail = testMailString.split(';');
        testMail.map((element) => {
          testMailArr.push(element);
        });
      }

      let personalizations = [];
      testMailArr.map((record) => {
        personalizations.push({
          to: [
            {
              email: record,
            },
          ],
          substitutions: {
            email: record,
            fullname: '【テスト　太郎】',
            familyname: '【テスト】',
            company: '【テスト株式会社】',
            department: '【テスト部署名】',
            department1: '【テスト部署名】',
            department2: '【テスト部署名2】',
            department3: '【テスト部署名3】',
            department4: '【テスト部署名4】',
            department5: '【テスト部署名5】',
            department6: '【テスト部署名6】',
            department7: '【テスト部署名7】',
            tname: '【テスト研修】',
            target: '【テスト対象者】',
            emp_no: '【テスト社員番号】',
            init_pass: '【テスト初期パスワード】',
            survey_display_name: '【テスト診断表示名】',
            first_delivery_date: '【4月21日(火)】',
            due_datetime: '【2026年4月21日（火）18:00】',
            extended_due_datetime: '【2026年4月28日（火）18:00】',
            multiple_choice_count: '【00】',
            free_text_count: '【00】',
            time_required: '【15】',
          },
        });
      });
      mailList = {
        personalizations: personalizations,
        from: {
          email: selMtInfo.from_mail, // 送信元アドレス
          name: selMtInfo.from_name, // 送信者名
        },
        subject: selMtInfo.subject,
        html: selMtInfo.body.replace(/\r?\n/g, '<br>'),
        substitutionWrappers: ['{$', '$}'],
        headers: {
          'X-Sent-Using': 'SendGrid-API',
        },
      };

      const sendMailResult = await Axios.post('/api/sendMail', {
        mailList: mailList,
        operation_log: 'SurveyTestMailSend',
      });
      if (sendMailResult.data.success) {
        message.success({
          content: 'メール送信完了！',
          key: 'mail',
          duration: 2,
        });
        return sendMailResult;
      } else {
        message.error({
          content: 'メール送信に失敗しました。',
          key: 'mail',
          duration: 2,
        });
        console.log({ sendMailResult });
        throw new Error('メール送信に失敗しました。');
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: 'メール配信で問題が発生しました。',
        key: 'mail',
        duration: 2,
      });
    }
  };

  const onChangeMtInfo = (value) => {
    if (value) {
      setSelMtId(value);
    }
  };

  const showConfirm = async () => {
    confirm({
      title: 'メールを本当に予約配信しますか？',
      content:
        'メール配信予約処理が完了し、ホームへ自動遷移されるまで、そのままお待ちください。',
      async onOk() {
        const result = await sendMailReservateHandler();
        if (result) {
          message.success({
            content: 'メールの配信予約が完了しました。ホームに戻ります。',
            key: 'mail',
            duration: 2,
          });
          props.history.push('/');
        } else {
          message.error({
            content: 'メール送信予約に失敗しました。',
            key: 'mail',
            duration: 2,
          });
          throw new Error('メール送信予約に失敗しました。');
        }
      },
      async onCancel() {
        message.success({
          content: 'メール配信予約を取り消しました。',
          key: 'mail',
          duration: 2,
        });
      },
    });
  };

  const onChangeSurvey = (v) => {
    setSelSurvey(survey.find((item) => item.survey_code === v));
    setSelMtId('');
  };

  const onChangeCCHandler = (e) => {
    setCCMailValue(e.currentTarget.value);
  };

  const onChangeBCCHandler = (e) => {
    setBCCMailValue(e.currentTarget.value);
  };

  const onChangeTestHandler = (e) => {
    setTestMailValue(e.currentTarget.value);
  };

  const onChangeDateTime = (date, dateString) => {
    setSendDateTime(date);
  };

  const csvDownloadHandler = async (event) => {
    event.preventDefault();
    try {
      message.loading({
        content: 'データ作成中...',
        key: 'makecsv',
        duration: 20,
      });
      const tempData = {};
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet('sheet1');
      const worksheet = workbook.getWorksheet('sheet1');
      let columns = [
        { header: 'ID', key: 'user_id' },
        { header: '会社名', key: 'company' },
        { header: '部署名', key: 'department' },
        { header: 'eメール', key: 'email' },
        { header: '名前', key: 'fullname' },
        { header: '社員番号', key: 'empNo' },
        { header: 'ロール', key: 'roletext' },
      ];
      worksheet.columns = columns;
      for (let i = 0; i < gUsers.length; i++) {
        const element = gUsers[i];
        tempData.user_id = element._id;
        tempData.company = element.company;
        tempData.department = element.department;
        tempData.email = element.email;
        tempData.fullname = element.fullName;
        tempData.empNo = element.emp_no;
        tempData.roletext = element.roleText;

        worksheet.addRow(tempData);
      }
      const uint8Array = await workbook.xlsx.writeBuffer();
      const blob = new Blob([uint8Array], {
        type: 'application/octet-binary',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      if (selQuestionSetId) {
        let selQuestionSetInfo = questionSet.find(
          (item) => item._id === selQuestionSetId
        );
        a.download = `Recurrent_Sruvey_RawData_${selSurveySeasonInfo.season_name}_${selQuestionSetInfo.set_name}_${isAnswerd}.xlsx`;
      } else {
        a.download = `Recurrent_Sruvey_RawData_${selSurveySeasonInfo.season_name}_${isAnswerd}.xlsx`;
      }
      a.click();
      a.remove();
      message.success({
        content: 'ダウンロード完了！',
        key: 'makecsv',
        duration: 2,
      });
    } catch (error) {
      console.log({ error });
      message.error({
        content: 'ダウンロード失敗！',
        key: 'makecsv',
        duration: 2,
      });
    }
  };

  // テーブル強化 PJ Ph.3 拡大: <Column> → columns 配列。rowSelection（条件付きチェックボックス）が
  // あるため reservedWidth で幅を予約。テキスト列はソート + 省略。
  const rawColumns = [
    ellipsisColumn({
      title: '名前',
      dataIndex: 'fullName',
      key: 'fullName',
      width: 160,
      sorter: textSorter('fullName'),
    }),
    ellipsisColumn({
      title: 'メール',
      dataIndex: 'email',
      key: 'email',
      width: 220,
      sorter: textSorter('email'),
    }),
    ellipsisColumn({
      title: '会社',
      dataIndex: 'company',
      key: 'company',
      width: 180,
      sorter: textSorter('company'),
    }),
    ellipsisColumn({
      title: '部署',
      dataIndex: 'department',
      key: 'department',
      width: 160,
      sorter: textSorter('department'),
    }),
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(
    rawColumns,
    { reservedWidth: 32 }
  );

  // 名前・メールでの表示絞り込み（送信対象・CSVは gUsers 全体のまま。あくまで一覧からの検索用）
  const displayedUsers = gUsers.filter((u) => {
    const nameOk =
      !searchName ||
      (u.fullName || '').toLowerCase().includes(searchName.toLowerCase());
    const emailOk =
      !searchEmail ||
      (u.email || '').toLowerCase().includes(searchEmail.toLowerCase());
    return nameOk && emailOk;
  });
  const isSearching = !!(searchName || searchEmail);

  return (
    <PageContainer fluid>
      <div style={{ marginTop: 16, marginBottom: 16 }}>
          ■絞り込み｜企業選択
          <Select
            showSearch
            style={{
              marginBottom: 10,
              marginLeft: 5,
              marginRight: 5,
              width: 200,
            }}
            placeholder="企業選択"
            optionFilterProp="children"
            onChange={onChangeGroup}
            value={selGroupCode}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {groups.map((element) => {
              return (
                <Option value={element.group_code} key={element._id}>
                  {element.group_name}
                </Option>
              );
            })}
          </Select>
          {selGroupInfo.survey_season && (
            <Fragment>
              サーベイシーズン選択:
              <Select
                showSearch
                style={{
                  marginBottom: 10,
                  marginLeft: 5,
                  marginRight: 5,
                  width: 250,
                }}
                placeholder="シーズン選択"
                optionFilterProp="children"
                onChange={onChangeSeasonFilter}
                value={selSurveySeasonIdFilter}
                defaultValue={selGroupInfo.survey_season[0].season_name}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {selGroupInfo.survey_season.map((element) => {
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.season_name}
                    </Option>
                  );
                })}
              </Select>
              {questionSet.length > 0 && (
                <Select
                  showSearch
                  style={{
                    marginBottom: 10,
                    marginLeft: 5,
                    marginRight: 5,
                    width: 200,
                  }}
                  placeholder="設問セット選択"
                  optionFilterProp="children"
                  onChange={onChangeQuestionSet}
                  value={selQuestionSetId}
                  defaultValue={questionSet[0].set_name}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {/* 360度系（40010/60020）は「全体」= 本人/協力者を区別せず1通配信を選択可 */}
                  {['40010', '60020'].includes(
                    selSurveySeasonInfo.survey_code
                  ) && (
                    <Option value="__ALL__" key="__ALL__">
                      全回答者
                    </Option>
                  )}
                  {questionSet.map((element) => {
                    return (
                      <Option value={element._id} key={element._id}>
                        {element.set_name}
                      </Option>
                    );
                  })}
                </Select>
              )}
            </Fragment>
          )}
          <Fragment>
            実施選択：
            <Select
              showSearch
              style={{
                marginBottom: 10,
                marginLeft: 5,
                marginRight: 5,
                width: 150,
              }}
              placeholder="回答選択"
              optionFilterProp="items"
              onChange={onChangeAnswer}
              value={isAnswerd}
              disabled={!selSurveySeasonId}
            >
              <Option value={9} key={9}>
                全体
              </Option>
              <Option value={0} key={0}>
                未回答
              </Option>
              <Option value={5} key={5}>
                回答済み
              </Option>
              <Option value={99} key={99}>
                ユーザー選択
              </Option>
            </Select>
          </Fragment>
          <Button
            onClick={csvDownloadHandler}
            disabled={!selSurveySeasonId}
          >
            CSVダウンロード
          </Button>
          <Fragment>
            {'　対象者：'}
            {isAnswerd === 99
              ? `${selectedRowKeys.length}名（選択中）`
              : `${gUsers.length}名`}
            {isSearching && `（表示：${displayedUsers.length}名）`}
          </Fragment>
        </div>
        <div style={{ marginBottom: 16 }}>
          名前：
          <Input
            allowClear
            placeholder="名前検索"
            style={{ width: 180, marginLeft: 5, marginRight: 15 }}
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
          メール：
          <Input
            allowClear
            placeholder="メール検索"
            style={{ width: 220, marginLeft: 5, marginRight: 15 }}
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
          />
          <Button
            onClick={() => {
              setSearchName('');
              setSearchEmail('');
            }}
          >
            クリア
          </Button>
        </div>
        <div ref={wrapRef}>
          <Table
            columns={columns}
            components={components}
            scroll={scroll}
            dataSource={displayedUsers}
            size="middle"
            rowKey="_id"
            rowSelection={
              isAnswerd === 99
                ? {
                    selectedRowKeys,
                    onChange: (newSelectedRowKeys) =>
                      setSelectedRowKeys(newSelectedRowKeys),
                  }
                : undefined
            }
          />
        </div>
        <Text strong>メールテンプレートを選択してください。（必須）</Text>
        <div>
          <Select
            showSearch
            style={{
              width: 400,
            }}
            placeholder="サーベイ選択"
            optionFilterProp="children"
            onChange={onChangeSurvey}
            value={selSurvey.survey_code}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {survey.map((element) => {
              return (
                <Option value={element.survey_code} key={element._id}>
                  {element.survey_name}
                </Option>
              );
            })}
          </Select>
          <Select
            showSearch
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 600,
            }}
            placeholder="テンプレート選択"
            optionFilterProp="children"
            onChange={onChangeMtInfo}
            value={selMtId}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {mtInfo.map((element) => {
              if (element.survey_code === selSurvey.survey_code) {
                return (
                  <Option value={element._id} key={element._id}>
                    {element.mt_name}
                  </Option>
                );
              }
            })}
          </Select>
          <br />
          <br />
          <Text strong>送信予定日時を選択してください。（必須）</Text>
          <br />
          <DatePicker
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            placeholder="送信予定日時を選択"
            onChange={onChangeDateTime}
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 200,
            }}
          />
          <br />
          <br />
          <Text strong>テストメールを送信します。</Text>
          <br />
          Test Mail To：
          <Input
            placeholder="メールアドレスを「;」区切りで入力してください"
            allowClear
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 350,
            }}
            onChange={onChangeTestHandler}
            value={testMailValue}
          />
          <Button
            onClick={sendTestMailHandler}
            disabled={!testMailValue || !selMtId}
          >
            メール発送
          </Button>
          <br />
          <Text strong>本メールを予約送信します。</Text>
          <br />
          CC：
          <Input
            placeholder="メールアドレスを「;」区切りで入力してください"
            allowClear
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 350,
            }}
            onChange={onChangeCCHandler}
            value={ccMailValue}
          />
          BCC：
          <Input
            placeholder="メールアドレスを「;」区切りで入力してください"
            allowClear
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 350,
            }}
            onChange={onChangeBCCHandler}
            value={bccMailValue}
          />
          <Button
            type="primary"
            onClick={showConfirm}
            disabled={
              !selGroupCode ||
              !selSurveySeasonId ||
              !selMtId ||
              !sendDateTime ||
              (isAnswerd === 99 && selectedRowKeys.length === 0)
            }
          >
            メール発送予約
          </Button>
        </div>
    </PageContainer>
  );
};

export default MailSendReservatePage;
